<div id="app-updater-modal">
    <div class="app-updater-modal-class" *ngIf='showModal'>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <img src="{{imageBasePath}}assets/img/Persistence/error.svg" class="modal-title-image"
                        alt="{{'FOC.DESKTOP.APP_UPDATE_ERROR_MODAL.IMAGE_ALT_TEXT' | translate}}">
                    <h5 class="modal-title-text">{{'FOC.DESKTOP.APP_UPDATE_ERROR_MODAL.MODAL_TITLE' | translate}}</h5>
                    <button type="button" class="close close-btn" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="m-0">{{'FOC.DESKTOP.APP_UPDATE_ERROR_MODAL.MODAL_MESSAGE_1' | translate}}</p>
                </div>
                <div class="modal-footer d-flex flex-row justify-content-center">
                    <button type="button" class="btn btn-purple-bordered mr-3" (click)="closeModalAndQuitApp()">
                        <span>{{'FOC.DESKTOP.APP_UPDATE_ERROR_MODAL.EXIT_APP' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>